export default {
  "about_label": "/HOOBUY GUIDE",
  "about_title": "HoobuySpreadsheet: A Lista Completa 2026",
  "about_description": "Descubra listas atualizadas, comparações reais e os melhores produtos organizados em spreadsheets exclusivos do Hoobuy. A forma mais inteligente de encontrar produtos baratos na China.",
  "about_stat_number": "14",
  "about_stat_label": "Categorias\nVerificadas",
  "hero_title_line1": "Compras Inteligentes",
  "hero_title_line2": "na China",
  "hero_subtitle": "Encontre os melhores produtos com o HoobuySpreadsheet — listas atualizadas, preços reais e fornecedores confiáveis para você economizar até 60%.",
  "hero_cta": "Acessar HoobuySpreadsheet",
  "trust_label": "CONFIANÇA",
  "trust_title": "Por que usar HoobuySpreadsheet?",
  "trust_1_title": "Atualizado Semanalmente",
  "trust_1_desc": "Nossas listas são revisadas e atualizadas toda semana para garantir que você tenha sempre os produtos mais recentes e os melhores preços do mercado.",
  "trust_2_title": "Produtos Verificados",
  "trust_2_desc": "Cada produto passa por verificação de qualidade. Trabalhamos apenas com fornecedores confiáveis para evitar golpes e produtos de baixa qualidade.",
  "trust_3_title": "Comparações Reais",
  "trust_3_desc": "Comparamos preços, qualidade e velocidade de entrega entre diferentes agentes para que você tome a melhor decisão de compra.",
  "comparison_label": "COMPARAÇÃO",
  "comparison_title": "Hoobuy vs Agentes",
  "comparison_subtitle": "Transparência Total",
  "comparison_desc": "Diferente dos agentes tradicionais que cobram taxas ocultas e têm processos pouco transparentes, o HoobuySpreadsheet oferece total visibilidade sobre preços, prazos e qualidade dos produtos. Você economiza tempo e dinheiro com informações organizadas e verificadas.",
  "comparison_cta": "Ver Comparação Completa",
  "categories_title": "Categorias",
  "categories_subtitle": "Explore nossas 14 categorias de produtos verificados",
  "blog_label": "GUIAS & REVIEWS",
  "blog_title_line1": "Hoobuy é Seguro?",
  "blog_title_line2": "Veja a Verdade",
  "blog_excerpt": "\"Muitas pessoas perguntam se comprar pelo Hoobuy é realmente seguro. A resposta curta é sim — mas com as ferramentas certas. O HoobuySpreadsheet foi criado exatamente para eliminar os riscos, organizando apenas fornecedores verificados e produtos com avaliações reais. Neste guia completo, mostramos como identificar vendedores confiáveis, evitar golpes comuns e garantir que sua compra chegue em perfeitas condições.\"",
  "blog_author": "Equipe HooBuy Boats",
  "blog_cta": "Ler Guia Completo"
}